import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface OfflineNotificationModalProps {
  isOpen: boolean
  onDismiss: () => void
}

const OfflineNotificationModal: React.FC<OfflineNotificationModalProps> = ({
  isOpen,
  onDismiss,
}) => {
  if (!isOpen) {
    return null
  }

  return (
    <div
      className={css(styles.overlay)}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onDismiss()
        }
      }}
      onKeyDown={(e) => e.key === 'Escape' && onDismiss()}
      role="presentation"
    >
      <div className={css(styles.modal)}>
        <div className={css(styles.header)}>
          <h2 className={css(styles.heading)}>
            Important Information - Signal unavailable
          </h2>
        </div>
        <div className={css(styles.body)}>
          <p className={css(styles.bodyText)}>
            Signal is unavailable. However, all your data, information, and
            activities are still recorded and saved, and will be automatically
            updated once the Signal returns.
          </p>
        </div>
        <div className={css(styles.footer)}>
          <button
            className={css(styles.button)}
            onClick={onDismiss}
            type="button"
          >
            I understand
          </button>
        </div>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1200,
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '450px',
    margin: '20px',
    overflow: 'hidden',
  },
  header: {
    backgroundColor: '#FFFFFF',
    padding: '24px 24px 16px 24px',
  },
  heading: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 600,
    color: '#000000',
    textAlign: 'center',
  },
  body: {
    backgroundColor: '#FEF3C7',
    padding: '20px 24px',
  },
  bodyText: {
    margin: 0,
    fontSize: '14px',
    color: '#000000',
    lineHeight: 1.6,
  },
  footer: {
    backgroundColor: '#FFFFFF',
    padding: '20px 24px 24px 24px',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: '#10B981',
    color: '#000000',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 32px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    ':hover': {
      backgroundColor: '#059669',
    },
  },
})

export default OfflineNotificationModal
